import { Text, VFlow } from 'bold-ui'
import { Ellipsis } from 'components/Ellipsis'
import { css } from 'emotion'
import { useServerTime } from 'hooks/useServerTime'

import { formatPlanoCuidadoData } from '../../utils/util-plano'
import { PlanoCuidadoModel } from '../model'

interface HistoricoPlanoCuidadoProps {
  planoDeCuidado: PlanoCuidadoModel
}

export const HistoricoPlanoCuidado = (props: HistoricoPlanoCuidadoProps) => {
  const { planoDeCuidado } = props

  const { getServerTimeNow } = useServerTime()
  const now = getServerTimeNow()

  return (
    <VFlow vSpacing={0}>
      <Text fontWeight='bold'>
        {formatPlanoCuidadoData(planoDeCuidado.dataDescricao, now)} |{' '}
        {planoDeCuidado.atendimentoProfissionalObservacao.atendimentoProfissional.lotacao.profissional.nome} -{' '}
        {planoDeCuidado.atendimentoProfissionalObservacao.atendimentoProfissional.lotacao.cbo.nome.titleCase()}
      </Text>
      <Ellipsis maxLines={3}>
        <Text style={styles.descricao} dangerouslySetInnerHTML={{ __html: planoDeCuidado.descricao }} />
      </Ellipsis>
    </VFlow>
  )
}

const styles = {
  descricao: css`
    word-break: break-word;
  `,
}
